<template>
  <van-popup
    v-model="show"
    position="bottom"
    closeable
    :close-on-click-overlay="false"
    @close="close">
    <div class="popupContent">
      <div class="filedContent">
        <div class="popupTitle">Feedback</div>
        <div class="filedTitle"></div>
        <van-field
          v-model="content"
          rows="3"
          autosize
          type="textarea"
          maxlength="160"
          show-word-limit
          placeholder="Please enter"
        ></van-field>
        <van-button
          type="primary"
          class="submitBtn"
          @click="onSubmit"
          :disabled="disabled"
          :color="disabled ? '#DCDCDC' : '#4A44C6'"
        >Submit</van-button>
      </div>
      <div class="phoneContent">
        <div class="phoneTitle">You can also call customer service directly</div>
        <div class="bottom-btn">
          <div class="btn-left"  :data-clipboard-text="phone">{{ phone }}</div>
          <div class="btn-right" @click="copy">Copy</div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import ClipboardJS from 'clipboard'
import { Toast } from 'vant'
import { getCustomerPhone, submitComplaint } from '@/views/order/lib'

export default {
  props: {
    title: {
      type: String,
      required: ''
    }
  },
  data() {
    return {
      show: true,
      content: '',
      phone: ''
    }
  },
  mounted() {
    getCustomerPhone().then(res => {
      this.phone = res.same.discourse
    })
  },
  computed: {
    disabled() {
      return !this.content
    }
  },
  methods: {
    onSubmit() {
      const params = {
        necessarily: this.content,
        organizational: this.title
      }
      submitComplaint(params).then(res => {
        if(res.authority === '200') {
          Toast("Sent successfully")
          this.content = ''
          this.close()
        }
      })
    },
    copy() {
      if (this.copynum) {
        this.copynum.destroy()
      }
      this.copynum = new ClipboardJS('.btn-left')
      this.copynum.on('success', (e) => {
        Toast('Copy successfully')
        e.clearSelection()
      })
      this.copynum.on('error', function (e) {
        console.error('Action:', e.action)
        console.error('Trigger:', e.trigger)
      })
      this.copynum.onClick({ currentTarget: document.querySelector('.btn-left') })
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="less">
.van-popup {
  border-radius: 20px 20px 0 0;
}
.popupContent {
  background: linear-gradient( 180deg, #E9E9FF 0%, #F4F5FB 100%);
  padding-top: 20px;
  .filedContent {
    padding: 0 30px;
    .popupTitle {
      color: #222222;
      font-size: 16px;
      font-weight: 500;
      text-align: left;
      margin-bottom: 30px;
    }
    .van-field {
      border-radius: 10px;
    }
    .submitBtn {
      width: 100%;
      height: 50px;
      border-radius: 25px;
      margin-top: 30px;
      color: #fff;
      font-size: 16px;
      font-weight: 500;
    }
  }
  .phoneContent {
    margin-top: 30px;
    padding: 30px;
    padding-bottom: calc(var(--app-bottom-tabbar-height) + 30px);
    border-radius: 20px 20px 0 0;
    background-color: #fff;
    .phoneTitle {
      color: #222222;
      font-size: 14px;
      text-align: left;
    }
    .bottom-btn{
      width: 100%;
      height: 50px;
      margin-top: 10px;
      display: flex;
      border: 1px solid #928FFF;
      border-radius: 25px;
      justify-content: space-between;
      .btn-left{
        display: flex;
        font-size: 16px;
        color: #222222;
        font-weight: 500;
        line-height: 1;
        flex: 1;
        border-radius: 25px;
        padding: 17px 0 17px 20px;
      }
      .btn-right{
        width: 103px;
        background: #928FFF;
        border-radius: 25px;
        font-size: 16px;
        font-weight: 500;
        color: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
/deep/ .van-field__control {
  height: 60px !important;
  max-height: 60px !important;
}
/deep/ .van-button--primary {
  border: none;
}
</style>